module.exports = __webpack_public_path__ + "static/img/1.5b73ff2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R290/1.jpg
// module id = a3OD
// module chunks = 1